import styled from 'styled-components'
import Box from '@mui/material/Box'
import Icon from 'components/Icon'
import IconError from 'components/CommonUI/IconError'

const StyledCircleFrame = styled(Box).attrs(props => ({
  height: '90px',
  width: '90px',
  bgcolor: 'background.neutralCool_75.main',
  color: 'background.neutralCool_75.text',
  overflow: 'hidden',
  display: 'grid',
  alignContent: 'center',
  justifyContent: 'center',
  justifySelf: 'center',
  position: 'relative',
  ...props,
}))`
  border-radius: 50%;
`

const CircleFrame = ({
  error,
  icon,
  iconProps = {},
  children,
  ...props
}) => {

  return (
    <StyledCircleFrame
      {...props}
    >
      <IconError
        hide={!error}
      >
        {icon && (
          <Icon
            icon={icon}
            {...iconProps}
          />
        )}
        {!icon && children}
      </IconError>
    </StyledCircleFrame>
  )
}

export default CircleFrame
